import { Checkbox } from "@/components/ui/checkbox";
import type { Airport } from "@/types/airport";

export interface AirportRowProps {
  airport: Airport;
  onDeltaChange: (iata: string, delta: boolean) => void;
}

export function AirportRow({ airport, onDeltaChange }: AirportRowProps): React.ReactElement {
  return (
    <tr className="border-t border-border">
      <td className="p-2 font-mono text-xs">{airport.iata}</td>
      <td className="p-2">{airport.name}</td>
      <td className="p-2">{airport.city}</td>
      <td className="p-2">{airport.state}</td>
      <td className="p-2 capitalize">{airport.hub_size ?? "—"}</td>
      <td className="p-2 text-center">
        <Checkbox
          checked={airport.delta_served === 1}
          onCheckedChange={(checked) => onDeltaChange(airport.iata, checked === true)}
        />
      </td>
    </tr>
  );
}
